<section class="dynamic-collapse">
	<section class="dynamic-collapse-header">
		<div class="data">
			<svg width="13" height="51" viewBox="0 0 13 51" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M0.478516 6.88888V50.3148H12.8859V6.88889C12.8859 3.46267 10.1084 0.685181 6.68222 0.685181C3.25601 0.685181 0.478516 3.46267 0.478516 6.88888Z"
					class="svg-sign-first-bar" />
			</svg>
			<svg width="14" height="38" viewBox="0 0 14 38" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M0.740723 6.2963V37.3148H13.1481V6.29629C13.1481 2.87008 10.3706 0.0925903 6.94443 0.0925903C3.51822 0.0925903 0.740723 2.87009 0.740723 6.2963Z"
					class="svg-sign-scd-bar" />
			</svg>
			<img class="bottom-bar" src="../../assets/img/bottom-bar.svg" alt="">
		</div>
		<div class="data-info">
			<h3>Net Worth</h3>
			<!-- <h2><span>{{assets-debts | currency:'GBP':'symbol-narrow':'1.0'}}</span></h2> -->
			<h2>
				<div class="total-count"
					 *ngIf="assets-debts>=0">{{assets - debts | currency:'GBP':'symbol-narrow':'1.0'}}
				</div>
				<div class="total-count" *ngIf="assets-debts<0" style="color:red">
					({{(assets - debts) * -1 | currency:'GBP':'symbol-narrow':'1.0'}})
				</div>
			</h2>
		</div>
	</section>
	<section class="dynamic-collapse-main">
		<div class="dynamic-collapse-content">
			<li class="actual-section" (click)="setFilter('assets')" [ngClass]="{chosenTabClass:chosentab=='assets'}">
				<div class="summaries-details">
					<span class="item-name first-category">Assets</span>
					<!-- <span class="total-count">{{assets | currency:'GBP':'symbol-narrow':'1.0'}}</span> -->
					<span *ngIf="assets>=0" class="total-count">{{assets | currency:'GBP':'symbol-narrow':'1.0'}}</span>
					<span *ngIf="assets<0" style="color:red"
						  class="total-count">({{assets * -1 | currency:'GBP':'symbol-narrow':'1.0'}})</span>
				</div>
				<div class="triangle"></div>
			</li>
			<li class="actual-section" (click)="setFilter('debts')" [ngClass]="{chosenTabClass:chosentab=='debts'}">
				<div class="summaries-details">
					<span class="item-name scd-category">Debts</span>
					<!-- <span class="total-count">{{debts | currency:'GBP':'symbol-narrow':'1.0'}}</span> -->
					<span *ngIf="debts>=0" class="total-count">{{debts | currency:'GBP':'symbol-narrow':'1.0'}}</span>
					<span *ngIf="debts<0" style="color:red"
						  class="total-count">({{debts * -1 | currency:'GBP':'symbol-narrow':'1.0'}})</span>
				</div>
				<div class="triangle"></div>
			</li>
		</div>
	</section>
</section>
